import { X, Play } from "lucide-react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { useVideoModal } from "@/context/VideoModalContext";

export default function VideoModal() {
    const { isOpen, close } = useVideoModal();

    return (
        <DialogPrimitive.Root open={isOpen} onOpenChange={(o) => !o && close()}>
            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay
                    data-testid="video-modal-overlay"
                    className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
                />
                <DialogPrimitive.Content
                    data-testid="video-modal"
                    className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[calc(100vw-2rem)] max-w-3xl bg-white rounded-2xl shadow-2xl shadow-slate-900/20 border border-slate-200/70 p-5 sm:p-7 max-h-[calc(100vh-2rem)] overflow-y-auto data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
                >
                    <DialogPrimitive.Close
                        data-testid="video-modal-close"
                        className="absolute right-4 top-4 w-9 h-9 inline-flex items-center justify-center rounded-full text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-colors z-10"
                        aria-label="Luk"
                    >
                        <X className="w-4 h-4" />
                    </DialogPrimitive.Close>

                    <div className="pr-10">
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 text-[11px] font-semibold uppercase tracking-wider border border-blue-100">
                            <Play className="w-3 h-3" />
                            Demo-video
                        </span>
                        <DialogPrimitive.Title className="mt-3 text-xl sm:text-2xl font-bold text-slate-900">
                            Se MyServiceHelper i praksis
                        </DialogPrimitive.Title>
                        <DialogPrimitive.Description className="mt-1.5 text-sm text-slate-600 leading-relaxed">
                            Her kan du se, hvordan flowet går fra kundehenvendelse til færdig opgave.
                        </DialogPrimitive.Description>
                    </div>

                    <div data-testid="video-modal-placeholder" className="mt-5 relative aspect-video w-full rounded-xl bg-gradient-to-br from-slate-900 via-slate-900 to-indigo-950 overflow-hidden border border-slate-200">
                        <div className="absolute inset-0 bg-grid opacity-30" />
                        <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-blue-500/20 blur-3xl" />
                        <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-purple-500/20 blur-3xl" />
                        <div className="relative h-full w-full flex flex-col items-center justify-center text-center px-6">
                            <button
                                type="button"
                                className="group inline-flex items-center justify-center w-16 h-16 rounded-full bg-white text-blue-700 shadow-2xl shadow-blue-500/30 hover:scale-110 active:scale-95 transition-transform"
                                aria-label="Afspil placeholder-video"
                            >
                                <Play className="w-6 h-6 ml-0.5" fill="currentColor" />
                            </button>
                            <p className="mt-4 text-white/90 text-sm font-medium">Demo-video kommer snart</p>
                            <p className="mt-1 text-white/50 text-xs">Placeholder · videoen kan udskiftes når den er klar.</p>
                        </div>
                    </div>
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
}
